import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { UrlList } from 'app/main/pages/authentication/shared/url-list.enum';
import { environment } from 'environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../../main/pages/authentication/login/login.service";
import * as i4 from "../../services/local-storage.service";
const IS_ENABLED_LOGGING = environment.IS_ENABLED_LOGGING;
const URL_DOPPLER_MAIN = environment.URL_DOPPLER_MAIN;
const URL_PROFILE_INTEGRA = UrlList.URL_PROFILE_INTEGRATED;
export class AccountService {
    constructor(_http, router, loginService, _localStorageService) {
        this._http = _http;
        this.router = router;
        this.loginService = loginService;
        this._localStorageService = _localStorageService;
        this.urlSecurity = UrlList.URL_SECURITY;
        this.userAdminEvent = new Subject();
        this.isAdmin2 = new Subject();
        this.isAdmin2$ = this.isAdmin2.asObservable();
        this.isAdmin1 = new BehaviorSubject(false);
        this.isAdmin1$ = this.isAdmin1.asObservable();
        this.checkDopplerSession();
    }
    checkDopplerSession() {
        window.addEventListener('doppler-session-state-update', () => {
            const dopplerSessionState = window['dopplerSessionState'];
            // Log only in non-production mode
            if (IS_ENABLED_LOGGING) {
                console.log('DopplerSession: ', dopplerSessionState);
            }
            // Get UserProfile
            this.userProfile = this.getUserData();
            // Check if the user logged in externally and ended it
            if (dopplerSessionState &&
                dopplerSessionState.status === 'non-authenticated' &&
                this.userProfile &&
                this.userProfile['isExternal']) {
                this.endSessionDoppler();
            }
        });
    }
    endSessionDoppler() {
        const isRolAdmin = this.userProfile.authorities.includes('ROLE_ADMIN');
        // If you are an ADMIN user you are redirected to the doppler login
        if (isRolAdmin) {
            this.cleanDataAndLogout();
            window.location.href = `${URL_DOPPLER_MAIN}/login`;
            //this.router.navigateByUrl(`${URL_DOPPLER}/login`);
        }
        else {
            // If you are an ATC user you will be redirected to the beplic-doppler login
            this.defaultEndSession();
        }
    }
    cleanDataAndLogout() {
        this.loginService.logout();
    }
    defaultEndSession() {
        Swal.fire({
            title: 'Atención!',
            text: '¡Tu tiempo de sesión ha finalizado, vuelve a loguearte!',
            type: 'info',
            confirmButtonColor: '#e2ae2f',
            confirmButtonText: 'Aceptar',
            width: '40rem',
        }).then(result => {
            this.cleanDataAndLogout();
            this.router.navigateByUrl('pages/auth/login');
        });
    }
    verifyAccounyByExternalLogin(email) {
        const headers = new HttpHeaders().set('Skip-Authorization', 'true');
        return this._http.post(`${this.urlSecurity}/account/check-account/init`, email, {
            headers: headers,
        });
    }
    getUserData() {
        return (this.userProfile = this._localStorageService.getCurrentUser());
    }
    // TODO: metodo deprecado
    emitUserAdminEvent(value) {
        this.userAdminEvent.next(value);
    }
    // TODO: metodo deprecado
    getUserAdminEvent() {
        return this.userAdminEvent.asObservable();
    }
}
AccountService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.LoginService), i0.ɵɵinject(i4.LocalStorageService)); }, token: AccountService, providedIn: "root" });
